import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
  // drawer: true
  cancelTokenArr: [] // 取消请求token数组
}

const mutations = {
  // SET_DRAWER(state, payload) {
  //   state.drawer = payload
  // },
  pushToken(state, payload) {
    state.cancelTokenArr.push(payload.cancelToken)
  },
  clearToken({
    cancelTokenArr
  }) {
    cancelTokenArr.forEach(item => {
      item('路由跳转取消请求')
    })
    cancelTokenArr = []
  }
}

const actions = {
  // aGetSpliceVariantData(context) {
  //   getSpliceVariantData().then((res) => {
  //     console.log(res);
  //     let gene_names = res;
  //     context.commit('getSvData', [gene_names, cancer_types, as_types])
  //   }).catch((err) => {
  //     console.error(err);
  //   });
  // },
}


const modules = {

}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules
});